// What needs the signed-in person's attention, for the bell and the
// notifications page.
//   masjid users: new website messages, support replies from the Masjid Hub team
//   admins:       verification documents to check, open tickets
import { useGetMessagesQuery } from "../store/Reducer/messages";
import { useGetMyTicketsQuery } from "../store/Reducer/tickets";
import { useGetAdminStatsQuery } from "../store/Reducer/adminApi";

const POLL = { pollingInterval: 60_000 };

export const timeAgo = (date) => {
  if (!date) return "";
  const s = Math.max(0, (Date.now() - new Date(date).getTime()) / 1000);
  if (s < 60) return "just now";
  const units = [["day", 86400], ["hour", 3600], ["minute", 60]];
  for (const [name, secs] of units) {
    const n = Math.floor(s / secs);
    if (n >= 1) return `${n} ${name}${n > 1 ? "s" : ""} ago`;
  }
  return "";
};

export default function useNotifications(isAdmin = false) {
  const messages = useGetMessagesQuery({ status: "new" }, { skip: isAdmin, ...POLL });
  const tickets = useGetMyTicketsQuery(undefined, { skip: isAdmin, ...POLL });
  const stats = useGetAdminStatsQuery(undefined, { skip: !isAdmin, ...POLL });

  const items = [];
  if (isAdmin) {
    const s = stats.data?.data;
    const submitted = s?.accounts?.verification?.submitted || 0;
    if (submitted) {
      items.push({ id: "verify", title: `${submitted} masjid${submitted > 1 ? "s" : ""} waiting for verification`, text: "Check the documents they sent.", to: "/admin-dashboard/users" });
    }
    for (const [type, label, to] of [["support", "support ticket", "/admin-dashboard/support"], ["feature", "feature request", "/admin-dashboard/feature-requests"]]) {
      const open = s?.tickets?.[type]?.open || 0;
      if (open) items.push({ id: type, title: `${open} open ${label}${open > 1 ? "s" : ""}`, text: "Waiting for a reply.", to });
    }
  } else {
    for (const m of messages.data?.data || []) {
      items.push({ id: m._id, title: `New message from ${m.name || "a visitor"}`, text: String(m.message || "").slice(0, 90), time: m.createdAt, to: "/user-dashboard/messages" });
    }
    for (const t of tickets.data?.data || []) {
      if (t.lastReplyFromAdmin && !["resolved", "closed"].includes(t.status)) {
        items.push({ id: t._id, title: "Masjid Hub replied to your ticket", text: t.subject, time: t.updatedAt, to: `/user-dashboard/support/${t._id}` });
      }
    }
    items.sort((a, b) => new Date(b.time || 0) - new Date(a.time || 0));
  }

  const isLoading = isAdmin ? stats.isLoading : messages.isLoading || tickets.isLoading;
  return { items, isLoading };
}
